import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';
import { AccountPackageService } from '../service/account-package.service';

@Component({
  selector: 'app-view-account-service-package-new',
  templateUrl: './view-account-service-package-new.component.html',
  styleUrls: ['./view-account-service-package-new.component.scss']
})
export class ViewAccountServicePackageNewComponent implements OnInit {

  @Input() servicePackageData;
  @Input() isShowEditbtn = true;
  @Output() submitEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeEmitter: EventEmitter<any> = new EventEmitter<any>();
  applicableVehicleProfiles: Array<any> = [];
  revenueShare = null;
  productTypeMap = Constants.PRODUCT_TYPE_MAP;
  usagetierMap = Constants.USAGE_TIER_MAP;
  // productTypeMap = new Map([
	// 	["LICENSE_BASED", "License Fee"],
	// 	["DEFAULT_DATA_TRNS", "API Product"],
	// 	["DEFAULT_DATA_NOTIFY_TRNS", "API Transaction"],
	// 	["DATA", "Data Payload"],
	// 	["FLAT_RATE", "Flat Fee"],
	// 	["DEFAULT_SERVICE_RATES", "Default Service Rates"],
	// 	["DEFAULT_SERVICE_RATES_OVERAGE_PRICING", "Default Service rates Overage Pricing"]
	// ]);
  // usagetierMap = new Map([
	// 	["VEHICLE", "Per Vehicle"]
	// ]);
  // DEFAULT_REGION = "North America";
	// DEFAULT_LOCALES = [
	// 	{
	// 		"locale": "en_ES",
	// 		"language": "English",
	// 		"country": "US"
	// 	}
	// ];
	DEFAULT_COUNTRIES = ["USA"];
  countryPackageRatePlanMap = null;
  countries = [];
  selectedCountry = null;
  selectedCountryRatePlanList = [];
  selectedCountryRatePlan = null;
  billingProrations: Map<string, string> = Constants.BILLING_PRORATIONS;

  constructor(public utilService: UtilService, private apiService: ApiService, private authService: AuthenticationService, private toastService: ToastService, private packageService: AccountPackageService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }

  init() {
    console.log("Service package data : ", this.servicePackageData);
    if (this.servicePackageData && this.servicePackageData.revenueShares && this.servicePackageData.revenueShares.length > 0) {
      for (var i = 0; i < this.servicePackageData.revenueShares.length; i++) {
        var revShare = this.servicePackageData.revenueShares[i];
        if (revShare.party != null && revShare.party.type == 'OEM') {
          this.revenueShare = revShare;
          break;
        }
      }
    }

    this.getVehicleProfiles();

    if (this.servicePackageData.countries == null) {
      this.servicePackageData.countries = Constants.DEFAULT_COUNTRIES;
    }
    if (this.servicePackageData.locales == null) {
      this.servicePackageData.locales = Constants.DEFAULT_LOCALES;
    }
    if (this.servicePackageData.region == null) {
      this.servicePackageData.region = Constants.DEFAULT_REGION;
    }

    //TODO: remove after testing:
    // this.setTestValues();
    // console.log("Servicepackage data after setting test values: ", this.servicePackageData);
    //---- test code end----

    this.createCountryPackageRatePlanMap();
    console.log("CountryPackageRatePlanMap: ", this.countryPackageRatePlanMap);
  }

  editCLicked() {
    this.submitEmitter.emit(JSON.parse(JSON.stringify(this.servicePackageData)));
  }

  closeClicked() {
    this.closeEmitter.emit(JSON.parse(JSON.stringify(this.servicePackageData)));
  }

  isZeroFee(consolidatedRatePlan) {
    if (consolidatedRatePlan.ratePlanType == 'FLAT_RATE' || consolidatedRatePlan.ratePlanType == 'LICENSE_BASED') {
      if (consolidatedRatePlan.usageType == 'UNLIMITED_USAGE') {
        if (consolidatedRatePlan.rateTypes && consolidatedRatePlan.rateTypes.length > 0
          && consolidatedRatePlan.rateTypes[0].rates && consolidatedRatePlan.rateTypes[0].rates.length)
          if (consolidatedRatePlan.rateTypes[0].rates[0].fee && consolidatedRatePlan.rateTypes[0].rates[0].fee.value == 0)
            return true;
      }
    }
    return false;
  }

  isVariableRate(): boolean {

    if (this.servicePackageData.consolidatedRatePlan && this.servicePackageData.consolidatedRatePlan.rateTypes) {
      for (var i = 0; i < this.servicePackageData.consolidatedRatePlan.rateTypes.length; i++) {
        var rateType = this.servicePackageData.consolidatedRatePlan.rateTypes[i];
        for (var j = 0; j < rateType.rates.length; j++) {
          var rate = rateType.rates[j];
          if (rate.serviceRates && rate.serviceRates.length > 0) {
            return true;
          }
        }
      }
    }
    return false;
  }

  getTierRatesCount(rateTypes: any[]): number {
    let count = 0;
    if (!isNullOrUndefined(rateTypes) && rateTypes.length > 0) {
      rateTypes.forEach((tier: any) => {
        if (!isNullOrUndefined(tier.rates) && tier.rates.length > 0) {
          count = count + tier.rates.length;
        }
      });
    }
    return count;
  }

  isNewRatePlanAvailable(): boolean {
    let ratePlans = this.servicePackageData.packageRatePlans;
    let newRatePlan = ratePlans.find(ratePlan => (ratePlan.isActive && (!isNullOrUndefined(ratePlan.appliedFrom) && new Date(ratePlan.appliedFrom * 1000) > new Date())));
    if (!isNullOrUndefined(newRatePlan)) {
      return true;
    }
    return false;
  }

  getNewRatePlanAvailable() {
    let ratePlans = this.servicePackageData.packageRatePlans;
    let newRatePlan = ratePlans.find(ratePlan => (ratePlan.isActive && (!isNullOrUndefined(ratePlan.appliedFrom) && new Date(ratePlan.appliedFrom * 1000) > new Date())));
    if (!isNullOrUndefined(newRatePlan)) {
      return newRatePlan.appliedFrom * 1000;
    }
    return new Date();
  }

  getVehicleProfiles() {
    this.utilService.showSpinner();
    this.apiService.getPublishedVehicleProfilesToServicePackage(this.servicePackageData.servicePackageId).then((data) => {
      this.utilService.hideSpinner();
      console.log("add vehicle response ::", data);
      this.applicableVehicleProfiles = data.vehicleProfiles;
      /* this.handleShowingPublishToVehicleProfileButton();
      this.vehicleBrandService.assignedVehicleProfiles = this.applicableVehicleProfiles; */
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehicleProfiles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  showPackageRatePlan() {
    return this.packageService.showPackageRatePlan(this.servicePackageData);
  }

  getProductType(rateplanType) {
    console.log("productTypeMap: ", this.productTypeMap, " - ratePlanType: ", rateplanType);
    var value = this.productTypeMap.get(rateplanType);
    if (value != null)
      return value;
    else
      return rateplanType;
  }

  getUsageTier(licenseType) {
    var value = this.usagetierMap.get(licenseType);
    if (value != null) {
      return value;
    }
    else if (licenseType == null) {
      return "-";
    } else {
      return licenseType;
    }
  }

  getBaseTierMaximum(packageRatePlan, overageTierServiceFeeType) {
    var maximum = null;
    if (packageRatePlan.rateTypes != null) {
      for (var i = 0; i < packageRatePlan.rateTypes.length; i++) {
        if (packageRatePlan.rateTypes[i].scheme == 'Base') {
          for (var j = 0; j < packageRatePlan.rateTypes[i].rates.length; j++) {
            var rate = packageRatePlan.rateTypes[i].rates[j];
            if (overageTierServiceFeeType == rate.serviceFeeType) {
              maximum = rate.tier.maximum;
              break;
            }
          }
          if (maximum != null) {
            break;
          }
        }
      }
    }
    return maximum;
  }

  createCountryPackageRatePlanMap() {
    this.countryPackageRatePlanMap = new Map();
    this.servicePackageData.consolidatedRatePlans.forEach(packageRatePlan => {
      if (packageRatePlan.country == null) {
        packageRatePlan.country = "Regionwide";
      }
    });

    var uniqueCountries = Array.from(new Set(this.servicePackageData.consolidatedRatePlans.map((packageRatePlan) => packageRatePlan.country)));

    uniqueCountries.forEach(country => {
      this.countryPackageRatePlanMap.set(country, new Array());
    });

    this.servicePackageData.consolidatedRatePlans.forEach(packageRatePlan => {
      if (packageRatePlan.isActive) {
        this.countryPackageRatePlanMap.get(packageRatePlan.country).unshift(packageRatePlan);
      } else {
        this.countryPackageRatePlanMap.get(packageRatePlan.country).push(packageRatePlan);
      }

      // if (packageRatePlan.isActive) { //Default show global active plan.
      //   this.selectedCountry = packageRatePlan.country;
      // }
    });

    var dataUnlimitedRatePlan = this.getDataUnlimitedRatePlan();
    this.setDefaultUnlimitRatePlanInMap(dataUnlimitedRatePlan);

    this.selectedCountry = uniqueCountries[0];
    this.onCountrySelected(null);

    this.countries = [...this.countryPackageRatePlanMap.keys()];
    console.log("countries: ", this.countries);

    this.servicePackageData.consolidatedRatePlans.forEach(packageRatePlan => {
      if (packageRatePlan.country == "Regionwide") {
        packageRatePlan.country = null;
      }
    });
  }

  setDefaultUnlimitRatePlanInMap(data) {
    if (data != null) {
      for (let [key, values] of this.countryPackageRatePlanMap) {
        console.log(key, " = ", values);
        values.forEach(value => {
          value.rateTypes.forEach(rateType => {
            if (rateType.scheme == "Base" && rateType.rates != null) {
              rateType.rates.push(data);
            }
          });
        });
      }
    }
  }

  getDataUnlimitedRatePlan() {
    var dataUnlimitedRatePlan = null;
    for (var i = 0; i < this.servicePackageData.services.length; i++) {
      var service = this.servicePackageData.services[i];
      if (service.executionType == 'DATA') {
        for (var j = 0; j < service.serviceRatePlans.length; j++) {
          var serviceRatePlan = service.serviceRatePlans[j];
          if (serviceRatePlan.ratePlanType == 'DATA_PRODUCT') {
            dataUnlimitedRatePlan = {
              "serviceFeeType": serviceRatePlan.serviceFeeType,
              "chargeableUnit": serviceRatePlan.chargeableUnit,
              "fee": null,
              "services": [
                service.name
              ],
              "tier": {
                "maximum": "Unlimited"
            }
            }

            break;
          }
        }
      }
    }
    return dataUnlimitedRatePlan;
  }

  getActiveRatePlan(ratePlans) {
    var activeRatePlan = null; //ratePlans[0];
    if (ratePlans != null) {
      for (var i = 0; i < ratePlans.length; i++) {
        if (ratePlans[i].isActive) {
          activeRatePlan = ratePlans[i];
          break;
        }
      }
    }
    return activeRatePlan;
  }

  onCountrySelected(event) {
    console.log("Country selected: ", this.selectedCountry);
    this.selectedCountryRatePlanList = this.countryPackageRatePlanMap.get(this.selectedCountry);
    this.selectedCountryRatePlan = this.getActiveRatePlan(this.selectedCountryRatePlanList);
  }

  setTestValues() {
    this.servicePackageData.region = "Europe";
    this.servicePackageData.countries = ["Spain", "France"];
    this.servicePackageData.locales = [
      {
        "locale": "es_ES",
        "language": "Spanish",
        "country": "Spain"
      },
      {
        "locale": "fr_FR",
        "language": "French",
        "country": "France"
      }
    ];

    this.servicePackageData.consolidatedRatePlans = [
      {
        "isActive": true,
        "country": "Spain",
        "ratePlanType": "LICENSE_BASED",
        "packageType": "PREMIUM",
        "term": "MONTHLY",
        "usageType": "OVERAGE_CHARGING",
        "fee": {
          "value": 0.15,
          "currency": "USD"
        },
        "rateTypes": [
          {
            "scheme": "Base",
            "fee": {
              "value": 20,
              "currency": "USD"
            },
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 0.15,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ],
                "tier": {
                  "minimum": 1,
                  "maximum": 10
                }
              }
            ]
          },
          {
            "scheme": "Overage",
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 0.15,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ]
              }
            ]
          }
        ],
        "licenseType": "VEHICLE"
      },
      {
        "isActive": false,
        "country": "Spain",
        "fee": {
          "value": 21,
          "currency": "USD"
        },
        "ratePlanType": "LICENSE_BASED",
        "packageType": "PREMIUM",
        "term": "MONTHLY",
        "usageType": "OVERAGE_CHARGING",
        "rateTypes": [
          {
            "scheme": "Base",
            "fee": {
              "value": 21,
              "currency": "USD"
            },
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 0.25,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ],
                "tier": {
                  "minimum": 1,
                  "maximum": 11
                }
              }
            ]
          },
          {
            "scheme": "Overage",
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 0.35,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ]
              }
            ]
          }
        ],
        "licenseType": "VEHICLE"
      },
      {
        "isActive": true,
        "country": "France",
        "fee": {
          "value": 22,
          "currency": "USD"
        },
        "ratePlanType": "LICENSE_BASED",
        "packageType": "PREMIUM",
        "term": "MONTHLY",
        "usageType": "OVERAGE_CHARGING",
        "rateTypes": [
          {
            "scheme": "Base",
            "fee": {
              "value": 22,
              "currency": "USD"
            },
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 0.45,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ],
                "tier": {
                  "minimum": 1,
                  "maximum": 12
                }
              }
            ]
          },
          {
            "scheme": "Overage",
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 1.65,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ]
              }
            ]
          }
        ],
        "licenseType": "VEHICLE"
      },
      {
        "isActive": false,
        "country": "France",
        "fee": {
          "value": 30,
          "currency": "USD"
        },
        "ratePlanType": "LICENSE_BASED",
        "packageType": "PREMIUM",
        "term": "MONTHLY",
        "usageType": "OVERAGE_CHARGING",
        "rateTypes": [
          {
            "scheme": "Base",
            "fee": {
              "value": 30,
              "currency": "USD"
            },
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 4.15,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ],
                "tier": {
                  "minimum": 1,
                  "maximum": 15
                }
              }
            ]
          },
          {
            "scheme": "Overage",
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 4.35,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ]
              }
            ]
          }
        ],
        "licenseType": "VEHICLE"
      },
      {
        "isActive": true,
        "fee": {
          "value": 10,
          "currency": "USD"
        },
        "ratePlanType": "LICENSE_BASED",
        "packageType": "PREMIUM",
        "term": "MONTHLY",
        "usageType": "OVERAGE_CHARGING",
        "rateTypes": [
          {
            "scheme": "Base",
            "fee": {
              "value": 10,
              "currency": "USD"
            },
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 5.15,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ],
                "tier": {
                  "minimum": 1,
                  "maximum": 17
                }
              }
            ]
          },
          {
            "scheme": "Overage",
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 0.95,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ]
              }
            ]
          }
        ],
        "licenseType": "VEHICLE"
      },
      {
        "isActive": false,
        "fee": {
          "value": 22,
          "currency": "USD"
        },
        "ratePlanType": "LICENSE_BASED",
        "packageType": "PREMIUM",
        "term": "MONTHLY",
        "usageType": "OVERAGE_CHARGING",
        "rateTypes": [
          {
            "scheme": "Base",
            "fee": {
              "value": 22,
              "currency": "USD"
            },
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 7.15,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ],
                "tier": {
                  "minimum": 1,
                  "maximum": 16
                }
              }
            ]
          },
          {
            "scheme": "Overage",
            "rates": [
              {
                "serviceFeeType": "Geofence Monitor",
                "fee": {
                  "value": 2.25,
                  "currency": "USD"
                },
                "services": [
                  "Geofence Monitoring"
                ]
              }
            ]
          }
        ],
        "licenseType": "VEHICLE"
      }
    ];
  }
}
